import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const resultAttributes = [
  'url',
  'type',
  'title',
  'created',
  'summary',
  'image_style_uri',
  'article_type',
  'download_type',
  'e_learning_type',
  'event_type',
  'intervention_type',
  'research_type',
  'practical_example_type',
  'tool_type',
  'field_show_in_dossier',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'pillar',
    field: 'pillar',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
  {
    attribute: 'subject_name',
    field: 'subject',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
  {
    attribute: 'workfield_name',
    field: 'workfield',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: {
    field: 'created',
    order: 'desc',
  },
};
